import classNames from 'classnames';
import { FocusEventHandler, useState } from 'react';

import ArrowDownIcon from 'assets/icons/arrow_down.svg';

import Text from 'components/BaseHelpers/Text';

import type { OtherCollegeNavigationProps } from '../OtherCollegeNavigation';
import SubNav from './SubNav';

import styles from '../OtherCollegeNavigation.module.scss';

const DesktopNav = ({ dropdownLabel, dropdownMenu }: OtherCollegeNavigationProps) => {
  const [open, setOpen] = useState(false);

  const handleBlur: FocusEventHandler<HTMLElement> = (e) => {
    const target = e.currentTarget;

    requestAnimationFrame(() => {
      if (!target.contains(document.activeElement)) {
        setOpen(false);
      }
    });
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <nav
      onBlur={handleBlur}
      className={classNames(styles.nav, styles['nav--desktop'])}
      id="other-college-nav-label"
      aria-label={dropdownLabel}
    >
      <button
        className={styles.dropdownLabel}
        onClick={handleToggle}
        aria-label={`Submenu of ${dropdownLabel}`}
        aria-expanded={open}
      >
        <Text field={dropdownLabel} />
        <ArrowDownIcon aria-hidden className={styles.labelIcon} />
      </button>
      <SubNav open={open} {...dropdownMenu} />
    </nav>
  );
};

export default DesktopNav;
